/**
 * 答题-结算分享
 * auth：xuyan
 * time：2023-06-13 18:57
 */

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import html2canvas from 'html2canvas';
import './index.scss';
import { fetchShareInfoState } from '@/models/shareState';
import { ShareInfoModel } from '@/models/typing';
import { useRecoilRefresher_UNSTABLE, useRecoilValueLoadable } from 'recoil';
import ErrorPage from '@/components/Error';
import { DefaultLoadingPage } from '@/components/Loading';
import { useParams } from 'react-router-dom';
import { ShareText, shareBgSrc } from '@/utils/setting';

const SharePage = ({ shareInfo }: any) => {
  const [imgUrl, setImgUrl] = useState('');

  const [sharetext, setText] = useState(ShareText());
  const [sBgSrc, setSBgSrc] = useState(shareBgSrc());

  const navigate = useNavigate();

  //海报html中间内容
  const renderContent = () => {
    return (
      <>
        <div className='m-share-achievePic'>
          <img src={shareInfo.achieve?.img} alt='' />
        </div>
        <div className='m-share-text'>
          <div className='m-share-text__title'>
            我参与了COLG答题王活动，并在
            {shareInfo?.questionnaire_title}
            {shareInfo?.questionnaire_title &&
              `（${shareInfo?.questionnaire_remark}）`}
            中取得了绝佳成绩
          </div>
          <div className='m-share-text__result'>
            <span>
              答题数:
              <em className='highText'>{shareInfo.info.question_count}</em>
            </span>
            <span>
              错题数:<em className='highText'>{shareInfo.info.error_count}</em>
            </span>
            <span>
              正确率:<em className='highText'>{shareInfo.info.correct_pre}%</em>
            </span>
            <span className='alone'>
              答题时长:
              <em className='highText'>{shareInfo.info.answer_time}</em>
            </span>
          </div>
          <div className='m-share-text__slogan'>{sharetext}</div>
        </div>
      </>
    );
  };

  const getShareImageBase64 = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const imgDoc: any = document.querySelector('#shareImage');
        html2canvas(imgDoc, {
          useCORS: true,
          scale: window.devicePixelRatio < 3 ? window.devicePixelRatio : 2,
          allowTaint: true,
          height: imgDoc.scrollHeight,
          windowHeight: imgDoc.scrollHeight,
        }).then((canvas: any) => {
          const imgData = canvas.toDataURL('image/jpeg', 1.0);
          resolve(imgData);
        });
      }, 300);
    });
  };

  useEffect(() => {
    getShareImageBase64()
      .then((res: any) => {
        setImgUrl(res);
      })
      .catch((error) => {
        console.log('%cindex.tsx line:69 error', 'color: #007acc;', error);
      });
    setSBgSrc(shareBgSrc());
    setText(ShareText());
  }, []);

  return (
    // 页面显示答题信息
    <div
      className='m-share mobile-share'
      style={{
        backgroundImage: `url(
          ${sBgSrc}
        )`,
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
      }}
    >
      <div>
        {/* <div className='m-share-head'>
          <img src={require('../../../assets/img/0.png')} alt='' />
        </div> */}
        <div className='m-share-achievePic'>
          <img src={shareInfo.achieve?.img} alt='' />
        </div>
        <div className='m-share-text'>
          <div className='m-share-text__title'>
            我参与了COLG答题王活动，并在
            {shareInfo?.questionnaire_title}
            {shareInfo?.questionnaire_remark &&
              `（${shareInfo?.questionnaire_remark}）`}
            中取得了绝佳成绩
          </div>
          <div className='m-share-text__result'>
            <span>
              答题数:
              <em className='highText'>{shareInfo.info.question_count}</em>
            </span>
            <span>
              错题数:<em className='highText'>{shareInfo.info.error_count}</em>
            </span>
            <span>
              正确率:<em className='highText'>{shareInfo.info.correct_pre}%</em>
            </span>
            <span className='alone'>
              答题时长:
              <em className='highText'>{shareInfo.info.answer_time}</em>
            </span>
          </div>
          <div className='m-share-text__slogan'>{sharetext}</div>
        </div>
        <div className='m-share-btn'>请长按并保存图片分享</div>
      </div>
      {/* 海报html */}
      <div
        className='m-share share-canvas'
        id='shareImage'
        style={{
          backgroundImage: `url(
          ${sBgSrc}
        )`,
          backgroundSize: 'cover',
          backgroundPosition: 'top center',
        }}
      >
        <img
          className='share-canvas-logo'
          src={require('../../../assets/img/icon-colg.png')}
          alt=''
        />
        {renderContent()}
        <div className='share-canvas-qrcode'>
          扫码参与
          <br />
          答题王活动
          <img
            src='https://img-cos.colg.cn/uploads/image/colg_answer/bg_code/code.png/ori_png'
            alt=''
          />
        </div>
      </div>
      {imgUrl && (
        <div>
          <img className='shareCanvasImage' src={imgUrl} alt='' />
        </div>
      )}
      <div className='backBtn' onClick={() => navigate(-1)}></div>
    </div>
  );
};

export const MobileShare = () => {
  const { logId, achieveId, queId } = useParams();

  const { state, contents } = useRecoilValueLoadable<ShareInfoModel>(
    fetchShareInfoState({
      achieve_id: achieveId ?? '',
      answer_log_id: logId ?? '',
      questionnaire_id: queId ?? '',
    })
  );

  const refresh = useRecoilRefresher_UNSTABLE(
    fetchShareInfoState({
      achieve_id: achieveId ?? '',
      answer_log_id: logId ?? '',
      questionnaire_id: queId ?? '',
    })
  );

  // return <SharePage info={''} />;

  switch (state) {
    case 'hasValue':
      return <SharePage shareInfo={contents} />;
    case 'hasError':
      return (
        <ErrorPage
          message={contents.message}
          onRetry={() => {
            refresh();
          }}
        />
      );
    case 'loading':
      return <DefaultLoadingPage />;
  }
};
